export let hkMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"郵箱/手機號",
  "password":"密碼",
  "remember":"記住密碼",
  "forget":"忘記密碼？",
  "sign in":"登錄",
  "login":"登錄",
  "sign up now":"立即註冊",
  "apply":"立即申請帳號",
  "contact us":"聯繫我們",
  "Privacy Policy":"隱私政策",
  "Terms of Use":"服務協定",
  "copyright":"2017，上海移宇科技有限公司，保留所有權利。",

  "chooseLang":"選擇國家/地區和語言",
  "asia":"亞洲",
  "europe":"歐洲",

  "applyHcp":"申請HCP帳號",
  "sign up":"註冊",
  "Patient":"患者",
  "Caregiver":"監護人",
  "Email":"郵箱/用戶名",
  "Mobile":"手機",
  "Enter email":"輸入郵箱位址",
  "Enter mobile":"輸入手機號",
  "Verification":"驗證碼",
  "Invitation":"邀请码",
  "full name":"輸入真實姓名",
  "Enter pass":"輸入密碼",
  "org":"組織機構",
  "Register":"註冊",
  "send":"發送",
  "agree":"我已閱讀並同意Medtrum的",
  "privacy":"隱私政策",
  "and" :"及 ",
  "use":"服務協定",
  "errtip1-1":"您的郵箱位址將會成為您的用戶名,",
  "errtip1-2":" 請輸入有效的郵箱位址",
  "errtip2":"請輸入正确的手機號",
  "errtip3":"驗證碼輸入錯誤",
  "errtip4":"邀请码错误",
  "errtip5":"未輸入姓名",
  "errtip6":"你的密码必须不少于6位",
  "errtip7":"請輸入機構名",

  "errp1":"密碼必須由至少三種字元組成:",
  "errp2":"大寫字母、小寫字母、數位或特殊字元",
  "errp3":"密碼長度為6~20個字元",
  "errp4":"密碼不能使用用戶名",
  "errp5":"不能有三個以上連續的數字(如:123,321)",
  "errp6":"不能有三個以上連續的字母(如:abc,cba)",
  "errp7":"不能包含空格",

  "Find account":"找回密碼",
  "Enter username":"請輸入用戶名",
  "Next":"下一步",
  "Cancel":"取消",
  "Back":"返回",
  "Enter veri":"請輸入驗證碼",
  "Create new":"創建新密碼",
  "Verify notice":"請輸入您郵箱/手機中Medtrum公司發送的驗證碼",
  "Create new notice":"請輸入6位元新密碼",
  "New pass" :"新密碼",
  "Completed":"完成",
  "Created":"新密碼已創建.",
  "Login Now":"立即登錄",

  "Delete":"刪除",
  "New Patient":"添加患者",
  "Add Patient":"查找患者",
  "Filter":"篩選",
  "Name":"姓名",
  "Gender":"性別",
  "Age":"年齡",
  "Type":"糖尿病類型",
  "Duration":"病齡",
  "Connections":"帳號創建者",
  "UploadTime":"上傳時間",
  "Year":"年",
  "Years":"年",
  "Month":"月",
  "Month2":"月",
  "Months":"月",
  "Invite":"邀請",
  "Invited":"已邀請",
  "All":"全部",
  "Female":"女性",
  "Male":"  男",
  "Not Set":"未填寫",
  "Type 1":"類型 1",
  "Type 2":"類型 2",
  "Gestational":"妊娠糖尿病",
  "Prediabetes":"糖尿病前期",
  "LADA":"成人隱匿性免疫性糖尿病",
  "Apply":"保存",
  "addP":"添加患者",
  "newP":"新建患者",
  "findP":"查找患者",
  "disUn":"病類型未知",
  "ageUn":"未填寫年齡",
  "genUn":"未填寫性別",
  "GDRNF":"未填寫",
  "GDRF":"女",
  "GDRM":"男",
  "女":"男性",

  "DBTNF":"未填寫",
  "DBT1":"類型 1",
  "DBT2":"類型 2",
  "DBTLADA":"LADA",
  "DBTPRE":"前期",
  "DBTGEST":"DBTGEST",
  "前期":"前期",
  "beFore":"前期",
  "MODY":"其他",

  "No selection":"未填寫",
  "unspecif":"未填寫",
  "register":"患者",
  "hcp":"醫生",

  "BG":"血糖值",
  "CARB":"食物",
  "INS":"胰島素注射",
  "EXR":"運動",
  "OTR":"其他",
  "HBA1C":"HbA1c",
  "DOSE":"藥物",
  "URINEK":"尿酮",
  "HEL":"HEL",
  "OTR1":"其他",
  "Loading":"加載中",

  "home":"首頁",
  "pID":"患者編號",
  "fullName":"姓名",
  "gender":"性別",
  "height":"高",
  "weight":"體重",
  "cm":"釐米",
  "kg":"千克",
  "birthday":"出生日期",
  "disType":"糖尿病類型",
  "disDate":"確診日期",
  "Address":"地址",
  "Postcode":"郵編",
  "Inpatient":"住院資訊",
  "Yes":"是",
  "No":"否",
  "Pno":"住院編號",
  "Bno":"床位編號",
  "create":"創建",
  "Telephone":"座機",

  "enterU":"輸入用戶名（郵箱）",
  "search":"搜索",
  "noU":"未輸入用戶名",
  "searchR":"搜索结果",
  "uername":"用戶名",
  "alias":"昵稱",
  "remove":"移除",
  "viewG":"查看圖表",
  "sendR":"發送請求",
  "rSent":"請求已發送",
  "cancelR":"取消請求",
  "VcodeTip1":"驗證碼已發送到 ",
  "VcodeTip2":"中，請等待一分鐘，若仍然未收到，請點擊",
  "VcodeTip3":"重試",
  "Entercode":"輸入驗證碼",
  "Getcode":"獲取驗證碼",

  "messages":"消息",
  "profile":"個人信息",
  "sign out":"退出",
  "changeP":"修改密碼",
  "connection":"聯繫人",

  "myP":"個人資訊",
  "Portrait":"頭像",
  "Profession":"職業",
  "DPRONF":"未填寫",
  "DPROENDOCRIN":"內分泌醫師",
  "DPRODIABTRA":"糖尿病護理教育者",
  "DPRONURSE":"護理醫師",
  "DPRODIATIT":"營養師",
  "DPROOTR":"其他醫療服務人員",
  "Organization":"組織機構",
  "Bio":"簡介",
  "save":"保存",
  "oldPa":"舊密碼",
  "newPa":"新密碼",
  "RePa":"確認密碼",
  "forgetY":"忘記密碼",
  "applyM":"應用",
  "oldErr":"舊密碼輸入錯誤",
  "EntTheSame":"輸入相同密碼",
  "EnterOld":"輸入舊密碼",

  "pList":"患者列表",
  "connections":"患者列表",
  "settings":"設置",
  "monitor":"即時監控",
  "graphs":"報告",
  "events":"事件",
  "records":"病程記錄",
  "qPrint":"快速列印",

  "sensorIn":"血糖信息",
  "timeOfLaRead":"最近血糖更新時間",
  "tranSn":"發射器序號",
  "status":"狀態",
  "sensorLife":"血糖探頭剩餘使用時間",
  "lastSenorRead":"最近血糖讀數",
  "TranBattery":"發射器電量",
  "sg":"血糖",
  "alert":"告警",
  "target":"目標範圍",
  "hypo":"低限",
  "sensorGlucose":"血糖讀數",
  "calib":"校準",
  "newSen":"新探頭",
  "warm":"初始化",
  "InsulinPump":"胰島素泵",
  "timeOfLaPump":"最近一次泵資料更新時間",
  "pumpSN":"泵體控制器序號",
  "ReserviorLife":"儲藥貼剩餘時間",
  "InsulinLeft":"胰島素剩餘量",
  "basal":"基礎量",
  "bolus":"大劑量",
  "totalBasal":"基礎量總量",
  "lastBolus":"最近大劑量",
  "activeInsulin":"活性胰島素",
  "totalBolus":"大劑量總量",
  "tampBasal":"臨時基礎量",
  "normalBolus":"正常大劑量",
  "extendBolus":"擴展大劑量",
  "manualStop":"手動暫停",
  "autoStop":"自動暫停",
  "auto suspend":"自動暫停",
  "stop":"輸注停止",
  "newPatch":"新儲藥貼",
  "tempBasal":"臨時基礎量",
  "N":"正",
  "E":"擴",
  "CN1":"組正",
  "CE":"組擴",

  "staticSettings":"報告設置",
  "dataSource":"資料來源",
  "unit":"單位",
  "glucoseTarget":"血糖目標範圍",
  "overall":"總計",
  "Hypoglycemia":"低於3.1mmol/L（56mg/dL）",
  "timePeriod":"時間段",
  "postMeal":"餐後分析",
  "Breakfast":"早餐",
  "Lunch":"中餐",
  "Dinner":"晚餐",
  "night":"夜間",
  "Before":"前",
  "After":"後",
  "Low":"低限",
  "High":"高限",
  "From":"開始",
  "To":"結束",
  "Hours":"小时",
  "Reset":"恢復默認設置",
  "RealTime":"即時",
  "uploaded":"上傳",
  "sensor":"血糖探頭",
  "pdmSN":"手持機序號",
  "startTime":"開始時間",
  "endTime":"結束時間",
  "uploadTime":"上傳時間",
  "pdm":"手持機",
  "Uploaded":"上傳",
  "Patch Pump":"手持機",
  "overLapp":"數據重疊",
  "showAlert":"顯示告警",

  "dashboard":"綜合報表",
  "dboard_glucose_statistics":"統計",
  "dboard_glucose":"指尖血糖",
  "dboard_glucose_avg":"平均值",
  "dboard_sd":"標準方差",
  "dboard_num":"次數",
  "dboard_cgm":"動態血糖",
  "dboard_cgm_avg":"平均值",
  //"dboard_sd":"標準方差",
  //"dboard_num":"次數",
  "dboard_insulin":"胰島素",
  "dboard_insulin_avg":"平均每天輸注的胰島素",

  //"dboard_sd":"標準方差",
  //"dboard_num":"次數",
  "dboard_carbs":"食物",
  "dboard_carbs_avg":"平均每天攝入量",
  //"dboard_sd":"標準方差",
  //"dboard_num":"次數",
  "dboard_exercise":"運動",
  "dboard_exercise_avg":"平均每天運動時間",
  //"dboard_sd":"標準方差",
  //"dboard_num":"次數",
  "dboard_num_days":"# days",
  "est_a1c_t1":"估算糖化血紅蛋白：",
  "est_a1c_t2":"基於動態血糖值計算所得",
  "est_a1c_t3":"說明：估算的糖化血紅蛋白值不能替代實驗室所測量的值",
  "dboard_statistics":"統計",
  "dboard_BG":"血糖值",
  "dboard_SG":"動態血糖值",
  "dboard_BG_calibration":"BG/校準（每天）",
  "dboard_AUC_high":"AUC高>11.0mmol/L",
  "dboard_AUC_low":"AUC低<5.2mmol/L",
  "dboard_highest_value":"最高價值",
  "dboard_lowest_value":"最低價值",
  "dboard_pump":"泵",
  "dboard_avg_daily_dose":"平均每天輸注的胰島素",
  "dboard_SD":"標準方差",
  "dboard_daily_basal":"每日基礎量",
  "dboard_daily_bolus":"每日大劑量",
  "dboard_avg_bolus_num":"平均每天輸注大劑量次數",
  "dboard_avg_suspend_time":"平均暫停時間",
  "dboard_avg_reservoir_usage":"儲藥貼平均壽命",
  "dboard_days":"days",
  "dboard_manual_bolus":"手動大劑量（數量/次數）",
  "dboard_normal":"-正常",
  "dboard_extend":"-擴展",
  "dboard_combo":"-組合",
  "dboard_bolus_calculator":"大劑量嚮導（數量/次數）",
  "dboard_food_bolus":"-食物大劑量",
  "dboard_corr_bolus":"-校正大劑量",
  "dboard_override_add":"-向上調整(+)",
  "dboard_override_sub":"-向下調整(-)",

  "dboard_report":"綜合報表報告",

  "daily":"每日總結",
  "date":"日期",
  "print":"列印",
  "carbs":"食物",
  "exercise":"運動",
  "heavy":"劇烈",
  "Medium":"中度",
  "Light":"輕度",
  "dailyReport":"每日總結報告",
  "devices":"設備",
  "tran":"發射器",
  "pumpBase":"泵體控制器",
  "HbA1c":"糖化血紅蛋白",
  "statics":"統計",
  "glucose":"血糖",
  "item":"項",
  "BG1":"指尖血糖",
  "SG1":"血糖",
  "avgSD":"平均值(mmol/L)±標準差",
  "avgSD1":"平均值±標準差",
  "min":"最小值",
  "max":"最大值",
  "ofRead":"讀數",
  "ofHypo":"低血糖次數/持續時間",
  "ofAlert":"告警次數",
  "insulin":"胰島素",
  "insulin2":"胰島素",
  "totalDose":"全天輸注總量",
  "foodBolus":"食物大劑量",
  "Food+coor":"食物和校正大劑量",
  "calibBolus":"校正大劑量",
  "durationStop":"暫停輸注時間(分钟)",
  "ofPumpAlert":"泵告警次數",
  "ofMeal":"進餐次數",
  "totalExerTime":"運動總時間",
  "exerNum":"運動次數",
  "avgInten":"平均強度",
  "target1":"目標範圍",
  "high1":"高",
  "low1":"低",
  "BG Reading":"指尖血糖讀數",

  "dayByday":"多日流覽",
  "dayBydayRe":"多日總結報告",
  "period":"時間段",

  "sensorOverlay":"血糖疊加圖",
  "set":"設置",
  "setPeriod":"設置時間段",
  "Weekdays":"工作日",
  "Weekends":"週末",
  "Mon":"星期一",
  "Tue":"星期二",
  "Wed":"星期三",
  "Thur":"星期四",
  "Thu":"星期四",
  "Fri":"星期五",
  "Sat":"星期六",
  "Sun":"星期日",
  "Average":"平均值",
  "sensorOlRe":"血糖疊加圖報告",
  "Avg":"平均值",
  "±SD":"±标准差",
  "ofhypo":"低血糖次數",
  "Everyday":"每天",

  "TrendAna":"趨勢分析",
  "TrendRe":"趨勢分析報告",
  "sensorGlu":"血糖探頭讀數",
  "ofBGtest":"指尖血糖讀數（次數）",
  "Basics":"基本統計",
  "static":"統計",
  "Med":"中位數",
  "med":"中位數",
  "Q1":"1/4分位",
  "Q3":"3/4分位",
  "Q11":"1/4分位數",
  "Q31":"3/4分位數",
  "IQR":"四分位距",
  "SD":"標準差",
  "CV":"變異係數",
  "SE1":"均值標準誤差",
  "distri":"分佈",
  "stab":"穩定性",
  "#high":"#偏高",
  "#low":"#偏低",
  "aucBelow":"低限線下積分",
  "aucAbove":"高限線下積分",
  "bgRead":"指尖血糖讀數",
  "total":"總量",
  "ofBolus":"大劑量次數",
  "avgBolus":"大劑量平均值",
  "Dura1":"運動（分）",
  "Avg/Total":"平均值/總計",
  "high":"高",
  "low":"低限",
  "#hypo":"低血糖次數",
  "ofExer":"運動次數",

  "logbook":"日誌",
  "dailyTotal":"全天總量",
  "High Glucose":"血糖高",
  "Low Glucose":"血糖低",
  "No Active Patch":"無啟動儲藥貼",
  "Missed Meal":"錯過用餐時間",
  "Multiple BG Readings":"多個指尖血糖讀數",
  "Stop Patch":"儲藥貼終止",
  "Others":"其他",
  "Other Events":"其他事件",
  "logRe":"日誌報告",

  "DeviceSetting":"設備設置報告",
  "Insulin Pump":"胰島素泵",
  "MaxBasalRate":"基礎量最大值",
  "BasalPatterns":"基礎量程式",
  "Selected Basal Pattern":"啟動的基礎量程式",
  "Maximum Bolus":"大劑量最大值",
  "Combo/Extended Bolus":"組合/擴展大劑量",
  "BG Reminder":"指尖血糖提醒",
  "Bolus Increment":"大劑量步長",
  "Bolus Calculator":"大劑量嚮導",
  "Active Insulin Time":"活性胰島素",
  "IC Ratios":"胰島素食物比",
  "Insulin Sensitivity":"胰島素靈敏度",
  "BG Target":"目標血糖",
  "Bolus Reminder":"大劑量提醒",
  "CGM":"動態血糖",
  "CGM System":"動態血糖系統",
  "Glucose Unit":"血糖單位",
  "Glucose Limits":"血糖門限",
  "Predicitive Alerts":"血糖異常預測告警",
  "Rate Alerts":"血糖變化異常告警",
  "type":"類型",
  "time":"時間",
  "data":"數據",
  "Rate":"速率",
  "Calibration Reminder":"校準提醒",
  "Calibration Repeat":"校準重複告警",
  "Snooze":"重複告警間隔",
  "Audio Options":"聲音選項",
  "Confidence Reminder":"指令回應提示",
  "Backlight":"背光",
  "Sec":"秒",
  "Alarm Clock":"鬧鐘",
  "Patch Expiration":"儲藥貼過期告警",
  "Sensor Expiration":"探頭過期告警",
  "Hourly Max":"每小時最大輸注量",
  "Daily Max":"每天最大輸注總量",
  "Low Reservoir":"低儲藥量告警",
  "Low Suspend":"低血糖暫停輸注",
  "Predictive Low Suspend":"預測低血糖暫停輸注",
  "Rise":"上升",
  "Fall":"下降",
  "Auto Off":"自動暫停輸注",
  "Standard":"標準",
  "Exercise":"鍛煉",
  "Holiday":"假日",
  "ProgramA":"程式A",
  "ProgramB":"程式B",
  "--":"--",
  "Insulin":"胰島素",

  "SUSA":"自動暫停輸注告警",
  "SUSHM":"超出每小時最大量暫停輸注",
  "SUSDM":"超出每天最大量暫停輸注",
  "SUSLSG":"低血糖暫停輸注",
  "SUSPLSG":"預測低血糖暫停輸注",
  "Pump Restarted":"貼片泵重啟",
  "Meter BG Now":"立即輸入指尖血",
  "Sensor Exp in 2 Hours":"探頭2小時內過期",
  "Sensor Exp in 6 Hours":"探頭6小時內過期",
  "Sensor Exp in 30 Min":"探頭30分鐘內過期",
  "Sensor Calibration Error":"探頭校準錯誤",
  "Sensor Error":"無血糖讀數",

  "Device Settings Report":"設備設置報告",
  "Device Settings at":"設備設置時間",
  "24h Total":"24小時總量",
  "Start":"開始",
  "Combo/Ext Bolus":"組合/擴展大劑量",
  "Time Format":"時間制",
  "Device Options（CGM System)":"動態血糖系統",
  "Device Options（Insulin Pump)":"胰島素泵系統",
  "Dispay Settings (Screen)":"顯示（螢幕）",
  "Dispay Settings (Backlight)":"顯示（背光）",
  "Graph Range":"血糖趨勢圖顯示",
  "Range":"範圍",
  "Repeat":"模式",
  "Glucose Alerts":"血糖告警",
  "Alert Silence":"血糖告警靜音",

  "Create":"添加",
  "Event Filter":"篩選",
  "HbA1c1":"糖化血紅蛋白",
  "Urine Ketone":"尿酮",
  "Injection":"胰島素注射",
  "Other":"其他",
  "Event Type":"事件類型",
  "Details":"詳情",
  "Notes":"備註",
  "Source":"來源",
  "edit":"編輯",
  "Action":"操作",
  "EventReport":"事件匯總報告",
  "By Date":"按日期",
  "By Category":"按項目",
  "Event Summary":"事件匯總",
  "No data":"無數據",
  "No1":"無",
  "data1":"數據",
  "#":"次數",
  "BG Summary":"指尖血糖統計",
  "Carbs Summary":"食物統計",
  "Injection Summary":"胰島素注射統計",
  "Exercise Summary":"運動統計",
  "Input Notes":"輸入備註",

  "Profile":"個人資訊",
  "Complications":"併發症",
  "Concomitant diseases":"伴發病",
  "Suggestion":"建議",
  "Coronary heart disease":"冠心病",
  "High blood lipids":"高血脂",
  "High blood pressure":"高血壓",
  "Kidney disease":"腎病",
  "Neuropathy":"神經病變",
  "Obesity":"肥胖症",
  "Peripheral arterial disease":"外周動脈疾病",
  "Retinopathy":"視網膜病變",
  "Smoking addiction":"吸煙者",
  "Enter date":"輸入日期",
  "Enter suggestion":"輸入建議",
  "Enter Notes":"輸入備註",
  "Select":"選擇",
  "Prescription":"藥方",
  "Medicine":"藥物類型",
  "Dose":"用量",
  "Enter medicine":"輸入藥物類型",
  "Enter dose":"輸入藥量",
  "Enterdis":"輸入併發症",
  "Add note":"輸入備註",
  "Add Content":"不超過1000個字符",
  "Other suggestions":"其他建議",
  "OK":"確定",
  "HCP":"醫護人員",
  "Content":"內容",
  "Records Report":"病程記錄報告",

  "Quick Print":"快速列印",
  "Quick Print Settings":"快速列印設置",
  "Select duration":"選擇時間間隔",
  "One Week":"一周",
  "One Month":"一月",
  "One Quarter":"一個季度",
  "End date":"截止日期",
  "Yesterday":"昨天",
  "Last Sunday":"上周日",
  "Last Saturday":"上週六",
  "Last Day of Last Month":"上個月最後一天",
  "Last Day of Last Quarter":"上個季度最後一天",
  "Customized":"設置",
  "Week Filter":"星期刪選",
  "Select reports to print":"選擇需要列印的報告",
  "Daily Summary":"每日總結",
  "Day By Day Overview":"多日總結",
  "Sensor Overlay":"血糖疊加图",
  "Trend Analysis":"趨勢分析",
  "Logbook":"日誌",
  "Device Settings Review":"設備設置",
  "createReport":"創建報告",

  "Segment Analysis":"分段分析",
  "Sensor Glucose Profile":"動態血糖",
  "# of Boluses":"大劑量次數",
  "Bolus Insulin":"大劑量",
  "Basal Pattern":"基礎量程式",
  "Segment Analysis Report":"分段分析報告",
  "Avg Glucose":"血糖平均值",
  "Below":"低於",
  "In Target Range":"目標範圍",
  "Coefficient of variation":"變異係數",
  "% Time CGM Active":"CGM啟動時間百分比",

  "acceptTip":" 已授權監護。",
  "cancelTip":" 已取消對您的授權，如需遠程監護，請重新申請。",
  "rejectTip":" 拒絕了您的申請。",
  "Read":"閱讀",

  "Connection":"患者",
  "connections1":"聯繫人",
  "Add Connection":"添加患者",
  "SG":"血糖值",
  "Active Insulin":"活性胰島素",
  "Stop following":"停止監護",
  "Enter username (email)":"輸入用戶名（郵箱/手機號）",
  "Search results":"搜索結果",
  "Send request":"發送請求",
  "View graphs":"查看圖表",
  "Agree":"同意",
  "Deny":"拒絕",
  "Remove":"移除",
  "Cancel Requset":"取消申請監護的患者",
  "Remark":"備註",

  "Patient Profile":"患者信息",

  "Warm up":"初始化",
  "Monitoring":"正常監控中",
  "Transmitter Error":"發射器故障",
  "Sensor Failure":"血糖探頭失敗",
  "Sensor Expired":"血糖探頭過期",
  "Lost Sensor":"血糖探頭丟失",
  "Not Calibrated":"未校準",
  "Calibrating":"校準中",
  "Calibration Needed":"校準過期",
  "Calibration Error":"校準錯誤",
  "Charging Battery":"充電中",
  "Battery Charged":"充電完成",

  "To be filled":"等待灌藥",
  "Filled with insulin":"已灌藥",
  "Priming":"充盈中",
  "Priming completed":"充盈已完成",
  "Inserting needle":"正在注針過程中",
  "Patch activated":"注針已完成",
  "Delivering Basal":"正在輸注基礎量",
  "Exceeds Max 1 Hour Delivery":"超出每小時最大量暫停輸注",
  "Exceeds Max TDD":"超出每天最大量暫停輸注",
  "Suspend":"用戶手動暫停輸注",
  "Occlusion Detected":"儲藥貼堵塞",
  "Patch Expired":"儲藥貼過期",
  "Empty Reservoir":"儲藥貼空",
  "Patch Error":"儲藥貼故障",
  "Pump Base Error":"泵控制器故障",
  "Patch Battery Depleted":"電池沒電",
  "Magnetic sensor not calibrated":"磁感測器未校準",

  "On":"開啟",
  "on":"開啟",
  "Off":"關閉",
  "off":"關閉",

  "CORONARY_HEART_DISEASE":"冠心病",
  "HIGH_BLOOD_LIPIDS":"高脂血",
  "HIGH_BLOOD_PRESSURE":"高血壓",
  "KIDNEY_DISEASE":"腎病",
  "NEUROPATHY":"神經病變",
  "OBESITY":"肥胖症",
  "PERIPHERAL_ARTERIAL_DISEASE":"外周動脈疾病",
  "RETINOPATHY":"視網膜病變",
  "SMOKING_ADDICTION":"吸煙者",

  "saveTip":"保存成功!",
  "changePaTip":"密碼修改成功",
  "enterEmTip":"請輸入您的郵箱/手機",
  "verErrTip":"驗證碼輸入錯誤",
  "chooseEventTip":"選擇需要列印的事件",
  "chooseDataTip":"選擇需要列印的數據",
  "dateWrongTip":"截止日期不能小於開始日期",
  "infoWrongTip":"資訊未填寫完成",
  "createdSuccssTip":"創建成功",
  "selectData":"選擇要保存的數據",

  "acceSu":"已接受",
  "acceEr":"接受失敗",
  "rejeSu":"已拒絕",
  "rejeEr":"拒絕失敗",

  "userNotExist":"用戶名不存在",
  "Password incorrect":"密碼錯誤。",
  "UserType incorrect":"用戶類型錯誤",
  "registSuccess":"註冊成功",
  "registFailed":"註冊失敗",
  "sentSuccess":"發送成功",
  "sentFailed":"發送失敗",

  "Input error":"輸入錯誤",

  "deletePtip":"確定需要刪除這些患者嗎？",
  "deleteEvents":"請確認是否需要刪除這些事件？",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"請確認是否需要刪除這個事件？",
  "confirm":"確定",
  "deleteSuccess":"已刪除",
  "deleteFailed":"删除失敗",
  "modifySuccess":"修改成功",
  "modifyFailed":"修改失敗",
  "createSuccess":"創建成功",
  "createFailed":"創建成功",
  "editSuccess":"編輯成功",
  "editFailed":"編輯失敗",
  "Time overlapped":"時間重疊",

  "stopFollow":"你確定要停止監護此患者嗎？",
  "CancelTip1":"你確定要取消這個連接嗎？",

  "Warning":"提示",
  "agreeConnect":"點擊“同意”後，聯繫人將會看到您的血糖數據、胰島素泵數據及個人相關信息。",
  "denyConnect":"你確定要拒绝此聯繫人查看你的數據?",
  "deleteConnect":"確認是否要刪除此聯繫人，删除後，此聯繫人將不能再繼續查看你的數據。",

  "Choose the events to print":"選擇需要列印的事件",
  "tryAgain":"重試",
  "username and password is required":"請輸入用戶名和密碼",
  "A name is required":"請輸入姓名",
  "username is required":"請輸入用戶名",
  "The date choose wrong":"時間選擇錯誤",
  "Date no more than 14 days":"日期不能多於14天",

  "CancelTip":"確定刪除嗎？",
  "removeConnect":"刪除成功",

  "dateErr1":"选择的日期范围不能超过90天!",
  "dateErr2":"截止日期不能小於起始日期",

  "Not Filled":"未填寫",
  "Today":"今天",
  "duration":"病齡",
  "interval":"Interval",
  "7 days":"7天",
  "14 days":"14天",
  "30 days":"30 天",
  "90 days":"90 天",
  "g":"克",

  "Sound+Vibrate":"聲音+振動",
  "Sound":"聲音",
  "Vibrate":"振動",
  "Silent":"免打擾",
  "1":"一次",
  "2":"每天",
  "noMes":"無消息",
  "noConnect":"無聯繫人",
  "Customize":"設置",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"一月",
  "Feb":"二月",
  "Mar":"三月",
  "Apr":"四月",
  "May":"五月",
  "Jun":"六月",
  "Jul":"七月",
  "Aug":"八月",
  "Sep":"九月",
  "Oct":"十月",
  "Nov":"十一月",
  "Dec":"十二月",
  "ApplyTip":" 申請監護您的數據.",
  "noReadings":"無血糖讀數",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"已上傳數據",
  "daop_uploaded_data_text":"數據來源於EasyTouch移動應用程式或EasyView iPad移動應用",
  "daop_realtime_data":"即時數據",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"（U/H）",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"儲藥貼電量低",
  "Alerts_Patch_Battery_Depleted":"儲藥貼沒電", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"儲藥量低", // update
  "Alerts_Empty_Reservoir":"儲藥貼空",
  "Alerts_Patch_Expiration_Advisory":"儲藥貼過期預警",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"儲藥貼過期", // update
  "Alerts_Patch_Error":"儲藥貼故障",
  "Alerts_Pump_Base_Error":"泵控制器故障",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"儲藥貼堵塞", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"超過每天最大輸注量", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"超過每小時最大輸注量",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"預測低血糖暫停輸注", // update
  "Alerts_Low_Suspend":"低血糖暫停輸注",
  "Alerts_Auto_Off":"自動暫停輸注", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"血糖探頭丟失", // update
  "Alerts_Transmitter_Battery_Low":"發射器電量低",
  "Alerts_Charge_Transmitter":"發射器需充電",
  "Alerts_Sensor_Error":"無血糖讀數",
  "Alerts_Transmitter_Error":"發射器故障",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"血糖探頭失敗",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"立即輸入指尖血",
  "Alerts_Sensor_Exp_in_6_Hours":"探頭6小時內過期",
  "Alerts_Sensor_Exp_in_2_Hours":"探頭2小時內過期", // update
  "Alerts_Sensor_Exp_in_30_Min":"探頭30分鐘內過期",
  "Alerts_Sensor_Expired":"血糖探頭過期", // update
  "Alerts_Rapid_Rise":"上升快",
  "Alerts_Rapid_Fall":"下降低",
  "Alerts_High_Predicted":"預期血糖高",
  "Alerts_Low_Predicted":"預期血糖低",
  "Alerts_High_Glucose":"血糖高", // update
  "Alerts_Low_Glucose":"血糖低", // update
  "Alerts_Below_3.1_mmol/L":"低於3.1mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"發射器電量低",

  "Alerts_PDM_Battery_Low":"手持機電量低",
  "Alerts_Replace_Battery":"手持機立即充電",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"告警",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"泵",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"自動模式時長",
  "t1221_Average_SG_SD":"平均血糖±標準差",
  "t1221_Time_in_Target_Range":"目標血糖比例",
  "t1221_Time_above_Range":"高血糖比例",
  "t1221_Time_below_Range":"低血糖比例",
  "t1221_Auto_Basal_per_day":"自動基礎量(每天)",
  "t1221_Auto_Bolus_per_day":"自動大劑量(每天)",
  "t1221_Auto_Mode_Exits":"自動模式退出",
  "t1221_No_Sensor_readings":"無血糖讀數",
  "t1221_Max_Delivery":"最大輸注",
  "t1221_Min_Delivery":"最小輸注",
  "t1222_autoModeBasal":"自動模式基礎量",
  "t1222_autoModeCorrBolus":"自動模式校正大劑量",
  "t1222_autoSnack":"自動零食",
  "t1222_autoBreakfast":"自動早餐",
  "t1222_autoLunch":"自動午餐",
  "t1222_autoDinner":"自動晚餐",
  "t1222_autoExercise":"自動運動",
  "t1222_Snack":"零食",
  "t1222_Auto_Mode":"自動模式",
  "t1222_Time_in_Auto_Mode":"自動模式時長",
  "t1222_Avg_SD":"平均值(mmol/L)±標準差",
  "t1222_Target_Range":"目標血糖次數",
  "t1222_Above_Range":"高血糖次數",
  "t1222_Below_Range":"低血糖次數",
  "t1222_Auto_Mode_Exits":"自動模式退出次數",
  "t1221_Auto_Mode":"自動模式總結",
  "t1222_auto_basal":"自動基礎量",
  "t1222_auto_bolus":"自動大劑量",
  "t0805_User_Management":"用戶管理",
  "t0805_Patient_Management":"患者管理",
  "t0805_Operation_History":"操作歷史",
  "t0805_User_List":"用戶列表",
  "t0805_User":"用戶",
  "t0805_Time":"時間",
  "t0805_Operation_Type":"操作類型",
  "t0805_Back":"返回",
  "t0805_Add":"增加",
  "t0805_Delete":"刪除",
  "t0809_Add_User":"添加用戶",
  "t1028_Pattern_C":"程式C",
  "t1028_Pattern_D":"程式D",
  "t1029_Auto_meal_bolus":"自動餐食大劑量",
  "t1029_Auto_mode_correction_bolus":"自動模式校正大劑量",
  "t1029_Sick":"生病",
  "t1029_Auto_Mode_Feature":"自動模式功能",
  "t1029_Target_SG":"目標血糖",
  "t1029_Auto_Meal_Handling":"自動餐食調整",
  "t1029_Total_Daily_Dose":"每日輸注總量",
  "t1029_Pump_Light":"泵控制器燈",
  "t1029_Alerts_for_Hypo":"低血糖報警",
  "t1102_Out_of_Range":"泵通信超過範圍",
  "t1102_Command_Reminder":"命令提醒",
  "t1102_Alarms_Alerts_on_APP":"貼片泵報警",
  "t1102_Alarms_on_App":"APP中高優先順序報警",
  "t1102_Alerts_on_App":"APP低優先順序報警",
  "t1102_Factory_Calibration":"免校準",
  "t1102_Alerts_for_Low":"血糖低報警",
  "t1102_Alerts_for_High":"血糖高報警",
  "t1102_Alerts_for_Others":"其他報警",
  "t1102_Adjustment":"調整",
  "t1102_Suggested":"建議輸注值",
  "t1103_Glucose":"血糖",
  "t1103_CGM":"動態血糖",
  "t1103_Insulin":"胰島素",
  "t1103_Carbs":"食物",
  "t1103_Exercise":"運動",
  "t1103_Min_Max":"最小值/最大值",
  "t1103_Target_Range":"目標範圍",
  "t1103_Overall_Tine_In_Range":"總計: 時間範圍",
  "t1103_Basal":"基礎量",
  "t1103_Bolus":"大劑量",
  "t1103_Basal_Bolus":"基礎量&大劑量",
  "t1103_Auto_Mode_Time_In_Range":"自動模式: 時間範圍",
  "t1103_Time_below_range":"低血糖比例",
  "t1103_Time_above_range":"高血糖比例",
  "t1103_Time_in_target_range":"目標血糖比例",
  "t1103_Incorrect_Password":"密碼輸入錯誤，還剩$1次嘗試機會，請確認登錄密碼是否正確。",
  "t1103_Incorrect_locked":"密碼錯誤次數超過限制，帳戶已被鎖定，請$1分鐘後再試。",
  "t1104_The_data_is_from":"數據來源於EasySense移動應用程式或EasyPatch移動應用程式",
  "t1104_Privacy_Policy":"隱私政策和服務協定",
  "t1104_updated_privacy_policy":"我們最近更新了隱私政策和服務協定。請仔細閱讀，同意並接受全部條款後再使用EasyView。",
  "t1104_Disagree":"不同意",
  "t1104_Agree":"同意",
  "t1105_Upload_History":"上傳歷史",
  "t1105_Delete_Data":"刪除數據",
  "t1105_Target_Range":"目標範圍",
  "t1105_request_to_view_your_data":"$1請求查看您的數據。",
  "t1105_Recent_Updates":"最近更新",
  "t1108_No_data":"無數據",
  "t1108_Pump_Bash_SN":"泵體控制器序號",
  "t1108_Transmitter_SN":"發射器序號",
  "t1112_Normal_Glucose":"正常血糖",
  "t1112_Manual_Bolus_or_Modified_Bolus":"手動大劑量或修改過的大劑量",
  "t1112_Auto_Mode_Started":"自動模式開始",
  "t1112_Auto_Mode_Exit":"自動模式退出",
  "t1112_Normal_Bolus":"正常大劑量",
  "t1112_Extended_Bolus":"擴展大劑量",
  "t1112_Combo_Bolus":"組合大劑量",
  "t1112_Carbs":"碳水化合物量",
  "t1112_Glucose":"血糖",
  "t1112_BG":"指尖血糖",
  "t1112_Audio":"聲音",
  "t1112_Tone":"告警聲音",
  "t1112_Audio_Options":"聲音選項",
  "t1112_Weight_Unit":"體重單位",
  "t1112_Height_Unit":"身高單位",
  "t1112_Not_available":"無法使用",
  "t1112_Number":"序號",
  "t1112_days":"天數",
  "t1112_min":"分鐘",
  "t1113_days":"天",
  "t1215_Security":"安全",
  "t1215_MFA":"多重身份驗證",
  "t1215_Enter_verification_code":"輸入驗證碼",
  "t1215_Multi_factor_ON":"多重身份認證已開啟。驗證碼已發送至 $1， 請提交驗證碼。",
  "t1215_Verification_code_incorrect":"驗證碼錯誤",
  "t1215_Show_Glucose_Value":"顯示血糖值",
  "t1221_enter_verification_code":"請輸入發送到$1的6位驗證碼。",
  "t1221_Verification_Success":"驗證成功",
  "t1222_We_will_only_process":"未獲得您的同意，我們不會通過Medtrum應用程式或網站處理您的醫療數據。",
  "t1222_If_you_are_under_years":"未滿16周歲的未成年人必須獲得父母或者監護人的同意才可以註冊帳號。",
  "t1221_register_cn":"你有權利選擇不上傳任何設備數據到應用程式，在此情況下，其他人無法訪問數據。如果選擇不註冊Medtrum帳號登錄應用程式/網站，您的醫療數據只記錄並保存在設備中。",
  "t1221_register_eu":"如果您選擇註冊Medtrum帳戶並使用帳戶訪問Medtrum的應用程式，該應用程式上記錄的醫療數據將被上傳至Medtrum在歐洲的伺服器，並保存2年。你有權利選擇不上傳任何設備數據到應用程式，在此情況下，其他人無法訪問數據。如果選擇不註冊Medtrum帳號登錄應用程式/網站，您的醫療數據只記錄並保存在設備中。",
  "t1221_register_follow":"未獲得您的同意，我們不會通過Medtrum 應用程式或網站處理您的醫療數據。",
  "t1222_Terms_of_Use":"移宇科技的使用條款",
  "t1222_Privacy_Policy":"移宇科技的隱私政策",
  "t1222_Create_Account":"創建帳號",
  "t1222_Back":"返回",
  "t1222_Verify_your_account":"驗證您的賬號",
  "t1222_please_check_your_account":"我們將會把驗證碼發送到$1，請檢查您的賬號。",
  "t1222_I_Agree_to":"我同意$1",
  "t1223_Invalid_Verification_Code":"無效的驗證碼，請重試。",
}

//export default {hkMessages}



// WEBPACK FOOTER //
// ./src/lang/hk.js